/* eslint-disable camelcase -- FIXME: automatically added for existing issue */
import { pick, keys, first, get } from 'lodash';
import {
  provinceStateShortToLong,
  CANADA,
  UNITED_STATES,
  ENROLLMENT_TYPE_QLE,
  ENROLLMENT_TYPES,
} from 'common/constants';
import { navStatusTypes } from '../navigation';
import { isInvalidSelectionErrorType } from '../benefit-validation/error-metadata';
// eslint-disable-next-line import/no-extraneous-dependencies -- FIXME: automatically added for existing issue
import moment from 'moment';

export const enrollmentStepPrefix = 'enrollment_step_';

const normalizeLocation = location => ({
  ...location,
  postal_code: location.postal,
  province: provinceStateShortToLong[location.province] || location.province,
  state: provinceStateShortToLong[location.state] || location.state,
});

const normalizeNationalIdentificationNumber = ({
  national_identification_number,
  social_security_number,
}) => national_identification_number || social_security_number;

export const getProfileValuesFromSchema = (userData, schema) => {
  const profile = pick(userData, keys(schema));
  const location = first(userData.locations);
  const address = location
    ? pick(normalizeLocation(location), keys(schema))
    : null;
  return {
    ...profile,
    ...address,
    ...(schema.national_identification_number && {
      national_identification_number:
        normalizeNationalIdentificationNumber(userData),
    }),
    ...(profile.date_of_birth && {
      date_of_birth: moment.utc(profile.date_of_birth).toDate(),
    }),
  };
};

/**
 * `get_benefit_prices` and `get_benefit_selection` require user to a set value for
 * the `tobacco_user` property. This function is used to test that a server_error is
 * related to this property as we need to sometimes catch and continue app execution
 */

export const isTobaccoUserError = error =>
  /missing tobacco_user/.test(get(error, 'info.reason', ''));

export const hasNoDateOfBirthError = error =>
  /missing date_of_birth/.test(get(error, 'info.reason', ''));

export const isRecoverableGetBenefitSelectionError = error =>
  isTobaccoUserError(error) || hasNoDateOfBirthError(error);

/**
 * get_benefit_prices fails for spouse dependents over the age of 65.
 */
export const isOptionalSpousalLifeRateError = error =>
  /Could not find Optional Spousal Life Rate/.test(
    get(error, 'info.reason', ''),
  );

export const getStepStatus = (
  hasVisited,
  hasErrors,
  isCurrentStep,
  hasSubmitted,
  errorType,
) => {
  if (isCurrentStep) return navStatusTypes.IN_PROGRESS;
  if (hasVisited) {
    if (!hasErrors) return navStatusTypes.COMPLETE;
    if (hasSubmitted || isInvalidSelectionErrorType(errorType))
      return navStatusTypes.ERROR;
  }
  if (hasSubmitted && !hasVisited) {
    return navStatusTypes.ERROR;
  }
  return navStatusTypes.DEFAULT;
};

// Month D, YYYY - eg. October 30, 2019
export const dateFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
};

// e.g. Apr. 17, 2021
export const shortDateUTC = {
  timeZone: 'utc',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

const northAmericanCountries = [CANADA, UNITED_STATES];

// Checks if the country code is not CA or not US
export const isNorthAmerica = countryCode =>
  northAmericanCountries.includes(countryCode);

export const fiveDaysFrom = date => date + 5 * 24 * 3600 * 1000;

export const isLeagueHSA = (vendor, productType) =>
  productType === 'hsa' && vendor === 'league';

export const isQleEnrollment = enrollmentType =>
  enrollmentType === ENROLLMENT_TYPE_QLE;

export const isAnnualEnrollment = enrollmentType =>
  enrollmentType === ENROLLMENT_TYPES.ANNUAL;

export const isNewHireEnrollment = enrollmentType =>
  enrollmentType === ENROLLMENT_TYPES.NEW_HIRE;

export const isActivationEnrollment = enrollmentType =>
  enrollmentType === ENROLLMENT_TYPES.ACTIVATION;

export const zeroDollar = currency => ({
  F: 0,
  C: currency,
  M: 0,
});

// @TODO Remove Temporary feature flag for NEDT
export const isNEDTFlagOn = () =>
  window.localStorage.getItem('is_NEDT') === 'true';

// @TODO Remove Temporary feature flag for Decision Support
export const isDecisionSupportFlagOn = () =>
  window.localStorage.getItem('is_decision_support') === 'true';

// @TODO Remove Temporary feature flag for GE
export const isGEFlagOn = () => window.localStorage.getItem('is_GE') === 'true';

// @TODO Remove Temporary feature flag for Compliance
export const isComplianceFlagOn = () =>
  window.localStorage.getItem('is_compliance') === 'true';

export const lushUSFTBenefitsGuideLink =
  'https://storage.googleapis.com/prod_typeform_content/pricingtables/Lush/general/2023-2024%20-%20LUSH%20FT%20Benefits%20Guide%20-%20US.pdf';
export const lushUSPTBenefitsGuideLink =
  'https://storage.googleapis.com/prod_typeform_content/pricingtables/Lush/general/2023-2024%20LUSH%20PT%20Benefits%20Guide%20-%20US.pdf';
